import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import store from '@Store';
import Molecular from '@Services/Molecular';
import { RESET_STATE, UPDATE_STATE_PARAMS, INITIALIZE_MOLECULAR_DATA, typeOfMolecularModal } from './MolecularModalConstants';

export const updateStateParams = (params) => {
  return {
    type: UPDATE_STATE_PARAMS,
    params,
  };
};
export const initializeMolecularData = () => {
  Molecular.initialize();
  const { data } = Molecular;
  return {
    type: INITIALIZE_MOLECULAR_DATA,
    data,
  };
};
export const openMolecularModal = (props) => {
  return (dispatch) => {
    dispatch(
      updateDialog({
        id: typeOfMolecularModal,
        dialogType: typeOfMolecularModal,
        movable: false,
        backdrop: true,
        closeButton: false,
        updateStringTypeDataValue: props.updateStringTypeDataValue,
        className: 'molecular-modal-dialog-wrap react-dialogs-scrollable',
        ...props,
      })
    );
  };
};
export const closeMolecularModal = () => {
  return (dispatch) => {
    dispatch(
      closeDialog({
        id: typeOfMolecularModal,
      })
    );
  };
};
export const dispatchOpenMolecularModal = (...args) => {
  store.dispatch(openMolecularModal(...args));
};
export const dispatchCloseMolecularModal = () => {
  store.dispatch(closeMolecularModal());
};
export const resetState = () => {
  return {
    type: RESET_STATE,
  };
};
